import React, { memo, useState, useCallback } from 'react';
import { useAsyncFn } from 'react-use';
import { Modal } from '../../../../modal';
import { Button } from './../../../../button';
import { Icon } from './../../../../icon';
import { TextInput } from '../../../../text-input';
import { StyledModalBody } from './styled';
export const SaveModal = memo(function SaveModal({ isOpen, closeModal, onSave }) {
    const [errorText, setErrorText] = useState(undefined);
    const [name, setName] = useState('');
    const [{ loading }, saveAsync] = useAsyncFn(async (name) => {
        try {
            await onSave(name);
            setName('');
            setErrorText(undefined);
            closeModal();
        }
        catch (error) {
            setErrorText(error);
        }
    }, [onSave, setName, setErrorText, closeModal]);
    const onNameChange = useCallback(({ target }) => {
        setName(target.value);
        setErrorText(undefined);
    }, [setName, setErrorText]);
    const onNameClear = useCallback(() => {
        setName('');
        setErrorText(undefined);
    }, [setName, setErrorText]);
    const onCloseModal = useCallback(() => {
        setName('');
        setErrorText(undefined);
        closeModal();
    }, [setName, setErrorText, closeModal]);
    return (React.createElement(Modal, { onClose: onCloseModal, onEscapeKeydown: onCloseModal, onBackgroundClick: onCloseModal, isOpen: isOpen, title: "Save Search", actions: [
            React.createElement(Button, { key: "cancel", text: "Cancel", variant: "outline", disabled: loading, onClick: onCloseModal }),
            React.createElement(Button, { key: "save", text: "Save", color: "primary", disabled: name === '' || loading, isLoading: loading, onClick: () => saveAsync(name) })
        ] },
        React.createElement(StyledModalBody, null,
            React.createElement(TextInput, { value: name, onChange: onNameChange, label: "Search Name", placeholder: "Name Your Search", hintType: errorText ? 'error' : undefined, hint: errorText, textType: "info", appendInnerIcon: name.length > 0 ? (React.createElement(Button, { onClick: onNameClear, variant: "text", StartIcon: React.createElement(Icon, { name: "close_outline" }) })) : undefined }))));
});
